/**
 * Contatori puri della dashboard (E10 — completamento scaffold slice 1).
 * Funzioni di conteggio su dati già fetchati dagli hook feature esistenti:
 * nessuna chiamata di rete qui, solo derivazioni testabili.
 */

import type { GlobalCveEntry } from '../features/cve/types.js';
import type { SlaTimer } from '../features/srp/types.js';

const WINDOW_DAYS = 7;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Numero di CVE con sfruttamento attivo noto (KEV). */
export function countKnownExploited(entries: GlobalCveEntry[]): number {
  return entries.filter((entry) => entry.knownExploited).length;
}

/** Numero di CVE rilevate negli ultimi 7 giorni (boundary inclusivo; senza detectedAt escluse). */
export function countNewCves(entries: GlobalCveEntry[], now: Date): number {
  const windowStart = now.getTime() - WINDOW_DAYS * MS_PER_DAY;
  return entries.filter(
    (entry) => entry.detectedAt !== undefined && Date.parse(entry.detectedAt) >= windowStart,
  ).length;
}

/**
 * Numero di timer SLA con almeno una soglia warning/breached (final opzionale inclusa). Le
 * soglie col timer fermo (step registrato, thread chiuso) non sono a rischio.
 */
export function countSlaAtRisk(timers: SlaTimer[]): number {
  return timers.filter(isAtRisk).length;
}

function isAtRisk(timer: SlaTimer): boolean {
  const thresholds = [timer.slaState.early, timer.slaState.notification, timer.slaState.final];
  return thresholds.some((t) => t?.status === 'warning' || t?.status === 'breached');
}
